import BenefitsSection from '@/v2/components/sections/common/benefits-section'
import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSection from '@/v2/components/sections/common/service-tips-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'

import {
  benefitsSectionContent,
  faqSectionContent,
  forWhoSectionContent,
  heroSectionContent,
  packingTipsSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/summer-camp-shipping-page'

interface SummerCampShippingPageProps {}

const SummerCampShippingPage: React.FC<SummerCampShippingPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
        w-[282px] h-[197px] 
        md-mn:w-[345px] md-mn:h-[241px] 
        lg-mn:w-[448px] lg-mn:h-[313px] 
        xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[269px] xl-min:!h-[50px] md-mn:w-[240px] w-[278px] h-[44px]'
      />
      <WhyWeSection
        isBgDark
        {...whyWeSectionContent}
        sectionTitleClassName='md-mn:max-w-full max-w-[345px] md-mn:[&_h2]:px-0 [&_h2]:px-5'
        className='[&_button]:!w-[278px]'
      />
      <ServiceTipsSection
        {...serviceTipsSectionContent}
        sectionTitleClassName='xl-min:!max-w-[1047px] lg-mn:max-w-[692px] md-mn:max-w-[692px] max-w-[352px] xl-min:[&_p]:!w-full md-mn:[&_p]:w-[80%]'
      />
      <WhyWeSection
        isBgDark
        {...packingTipsSectionContent}
        className='[&_article]:bg-transparent [&_article]:border-none'
        sectionTitleClassName='md-mn:max-w-full max-w-[345px] [&_p]:px-2'
      />
      <BenefitsSection
        {...benefitsSectionContent}
        sectionTitleClassName='md-mn:max-w-full md-mn:[&_h2]:w-full [&_h2]:w-[70%] md-mn:[&_p]:w-full [&_p]:w-[90%]'
        className='md-mn:[&_article>div:first-of-type]:self-start'
      />
      <ForWhoSection
        isBgDark
        {...forWhoSectionContent}
        sectionTitleClassName='md-mn:max-w-full max-w-[352px] xl-min:[&_p]:!w-full md-mn:[&_p]:w-[80%]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        className='[&_article_button]:w-[304px]'
        imgClassName='xl-min:!w-[484.25px] xl-min:!h-[307px] md-mn:w-[310.91px] md-mn:h-[197px] w-[232px] h-[147px]'
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default SummerCampShippingPage
